import React, {useEffect, useState} from 'react';
import {REGISTRY_SINGLETON} from "../../scenes/Registry";
import {INITIAL_VOLUME, LOCAL_STORAGE_KEY_VOLUME} from "../../constants/sound";
import './VolumeSlider.css';
import {usePrev} from "../../hooks/react/usePrev";

const VolumeSlider = () => {
  const [volume, setVolume] = useState(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY_VOLUME);
    if (stored === null) {
      localStorage.setItem(LOCAL_STORAGE_KEY_VOLUME, INITIAL_VOLUME.toString());
      return INITIAL_VOLUME;
    }
    const parsed = parseFloat(stored);
    return isNaN(parsed) ? INITIAL_VOLUME : Math.max(0, Math.min(1, parsed));
  });

  const prevVolume = usePrev(volume);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY_VOLUME, volume.toString());


    if (prevVolume) {
      const timer = setTimeout(() => {
        const soundManager = REGISTRY_SINGLETON.getSoundManager();
        soundManager.updateBirdsVolume();
        soundManager.playMenuButtonClick();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [volume, prevVolume]);

  return (
    <div className="volume-slider-container">
      <img
        className="volume-slider-icon"
        src={'/img/icons/volume.png'}
        alt={'Громкость'}
      />
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={(e) => setVolume(parseFloat(e.target.value))}
        className="volume-slider"
      />
      <span className="volume-slider-value">{Math.round(volume * 100)}%</span>
    </div>
  );
};

export default VolumeSlider;
